<div class="modal-container">
  <div class="modal-header">
    <h2 mat-dialog-title>
      <mat-icon>print</mat-icon>
      <span>Estrutura do Produto</span>
    </h2>
    <button mat-icon-button (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content-body modal-print-container">
    @if (isLoading) {
    <div class="loading-container">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
    } @else {
    <div class="documento-cabecalho">
      @if (empresaLogo) {
      <img [src]="empresaLogo" class="documento-logo" alt="Logo da empresa" />
      }
      <div>
        <strong>{{ empresaNome }}</strong>
        @if (empresaEndereco) {
        <div class="documento-empresa-detalhe">{{ empresaEndereco }}</div>
        }
        @if (empresaCnpj) {
        <div class="documento-empresa-detalhe">CNPJ: {{ empresaCnpj }}</div>
        }
      </div>
    </div>

    <h3 class="documento-titulo">Ordem de Produção Nº {{ numero }} - Estrutura do Produto</h3>

    <div class="documento-identificacao">
      <div><span class="documento-label">Código (SKU)</span><span>{{ codigoSku }}</span></div>
      <div><span class="documento-label">Produto</span><span>{{ nomeProduto }}</span></div>
    </div>

    <table class="documento-tabela">
      <thead>
        <tr>
          <th>Produto</th>
          <th>Código (SKU)</th>
          <th>Unidade</th>
          <th class="text-end">Quantidade</th>
          <th class="text-end">Quantidade Total</th>
        </tr>
      </thead>
      <tbody>
        @for (linha of linhas; track $index) {
        <tr>
          <td [style.paddingLeft.px]="16 + linha.nivel * 20">
            @if (linha.isFabricado) {
            <span class="marcador-fabricado">▾</span>
            }
            {{ linha.nomeProduto }}
          </td>
          <td>{{ linha.codigoSku }}</td>
          <td>{{ linha.unidade }}</td>
          <td class="text-end">{{ linha.quantidadeUnitaria | abnt:'quantidade' }}</td>
          <td class="text-end">{{ linha.quantidadeTotal | abnt:'quantidade' }}</td>
        </tr>
        }
        @if (linhas.length === 0) {
        <tr>
          <td colspan="5" class="documento-vazio">Este produto não tem itens de composição cadastrados.</td>
        </tr>
        }
      </tbody>
    </table>
    }
  </div>

  <div class="modal-footer">
    <button mat-stroked-button class="btn-secondary" (click)="fechar()">Cancelar</button>
    @if (!isLoading) {
    <button mat-flat-button class="btn-primary" (click)="imprimir()">
      <mat-icon>print</mat-icon> Imprimir
    </button>
    }
  </div>
</div>